module.exports = __webpack_public_path__ + "img/kid.13c0aeba.png";